// extracted by mini-css-extract-plugin
export var button = "style-module--button--b4891";
export var large = "style-module--large--23258";
export var link = "style-module--link--627da";
export var noArrow = "style-module--noArrow--36763";
export var spinner = "style-module--spinner--9b43b";